<template>
    <v-card class="feed-card">
        <card-header :category="category" :createdBy="createdBy" :createdTime="createdTime" />
        <media-card v-if="type === 'media'" :image="image" />
        <text-card v-if="type === 'text'" :body="body" />
        <carousel-card v-if="type === 'carousel'" :miniCards="miniCards" v-on:click="clickFunction" v-on:changeFavorite="changeFavoriteFunction"/>
        <call-to-action v-for="(item, index) in mainLinks" :key="index + '-link'" :link="item.link" :title="item.title" :buttonText="item.buttonText" />
    </v-card>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import TextCard from './TextCard.vue';
import MediaCard from './MediaCard.vue';
import CardHeader from './CardHeader.vue';
import CallToAction from './CallToAction.vue';
import CarouselCard from './CarouselCard.vue';

export default Vue.extend({
    name: 'FeedCard',
    props: {
        createdBy: String,
        category: String,
        createdTime: Temporal.Instant as unknown as PropType<Temporal.Instant>,
        image: String,
        title: String,
        body: String,
        type: {
            type: String,
            validator: (val) => ['text', 'carousel', 'media'].includes(val as string)
        },
        // mainLinks are used for calls to action - should be array of objects each with a title, and optionally a link & buttonText (without the last 2 it will just display the text)
        mainLinks: Array,
        miniCards: Array,
        clickFunction: Function,
        changeFavoriteFunction: Function,
        titleLink: String,
    },
    components: {
        TextCard,
        MediaCard,
        CardHeader,
        CallToAction,
        CarouselCard,
    }
})
</script>,
        CardHeader
